import { getEdgeUrl } from '@/lib/getEdgeUrl';
import i18n from '@/settings/i18n';
import { Content } from './types';

const t = i18n.init('homepage');

const smartphonesDesktop = getEdgeUrl(
  'images/homepage/banner/v2/smartphones-desktop.png',
);
const smartphonesMobile = getEdgeUrl(
  'images/homepage/banner/v2/smartphones-mobile.png',
);
const LaptopsDesktop = getEdgeUrl('images/homepage/banner/laptops-desktop.png');
const LaptopsMobile = getEdgeUrl('images/homepage/banner/laptops-mobile.png');
const IpadsDesktop = getEdgeUrl('images/homepage/banner/ipads-desktop.png');
const IpadsMobile = getEdgeUrl('images/homepage/banner/ipads-mobile.png');

const smartwatchesDesktop = getEdgeUrl(
  'images/homepage/banner/v2/smartwatches-desktop.png',
);
const smartwatchesMobile = getEdgeUrl(
  'images/homepage/banner/v2/smartwatches-mobile.png',
);
const kitchenDesktop = getEdgeUrl(
  'images/homepage/banner/v2/kitchen-desktop.png',
);
const kitchenMobile = getEdgeUrl(
  'images/homepage/banner/v2/kitchen-mobile.png',
);

const getConfig = (): Content[] => [
  {
    title: t`Premium Smartphones. Better Prices.`,
    description: {
      desktop: t`Expertly refurbished, quality guaranteed, with savings up to 70% less than new.`,
      mobile: t`Expertly refurbished, quality guaranteed, with savings up to 70% less than new.`,
    },
    cta: {
      label: t`Shop Now`,
      link: 'smartphones',
      tracking: 'Smartphones',
    },
    banner: { desktop: smartphonesDesktop, mobile: smartphonesMobile },
    theme: 'light',
  },
  {
    title: t`Refurbished Laptops`,
    description: {
      desktop: t`Explore a wide variety of expertly refurbished laptop picks - up to 70% off.`,
      mobile: t`Expertly refurbished laptop picks up to 70% off.`,
    },
    cta: {
      label: t`Shop Now`,
      link: 'laptops',
      tracking: 'Laptops',
    },
    banner: { desktop: LaptopsDesktop, mobile: LaptopsMobile },
    theme: 'light',
  },
  {
    title: t`Refurbished iPads`,
    description: {
      desktop: t`On the go or on the fly - refurbished iPad upgrades that can get it done.`,
      mobile: t`On the go or on the fly - refurbished iPad that can get it done.`,
    },
    cta: {
      label: t`Shop Now`,
      link: 'apple-ipads',
      tracking: 'iPads',
    },
    banner: { desktop: IpadsDesktop, mobile: IpadsMobile },
    theme: 'dark',
  },
  {
    title: t`Refurbished Smartwatches`,
    description: {
      desktop: t`Smarter moves, sleeker looks — refurbished smartwatches that keep up and stand out.`,
      mobile: t`Smarter moves, sleeker looks — refurbished smartwatches that keep up and stand out.`,
    },
    cta: {
      label: t`Shop Now`,
      link: 'smartwatches',
      tracking: 'Smartwatches',
    },
    banner: { desktop: smartwatchesDesktop, mobile: smartwatchesMobile },
    theme: 'light',
  },
  {
    title: t`Refurbished Home & Kitchen`,
    description: {
      desktop: t`From coffee brewers to vacuum cleaners, Reebelo delivers refreshed essentials to elevate every day.`,
      mobile: t`From coffee brewers to vacuum cleaners, Reebelo delivers refreshed essentials to elevate every day.`,
    },
    cta: {
      label: t`Shop Now`,
      link: 'home/02n5t7v7l3p4',
      tracking: 'Home & Kitchen',
    },
    banner: { desktop: kitchenDesktop, mobile: kitchenMobile },
    theme: 'dark',
  },
];

export default getConfig;
